import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, FILE_URL } from "../lib/api";

const FALLBACK_IMG = "https://images.unsplash.com/photo-1620656798579-1984d9e87df7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function SobrePage() {
  const [c, setC] = useState(null);
  useEffect(() => {
    api.get("/settings/about").then((r) => setC(r.data));
  }, []);
  if (!c) return <div className="p-20 text-center text-[#A8A8A8]">Carregando...</div>;
  const IMG = c.photo_path ? FILE_URL(c.photo_path) : FALLBACK_IMG;

  return (
    <div data-testid="sobre-page">
      <section className="relative h-[60vh] min-h-[400px] overflow-hidden">
        <img src={IMG} alt="Prize Joias" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/60" />
        <div className="relative h-full flex items-center justify-center text-center px-6">
          <div>
            <p className="overline text-[#B8A88A] mb-4">Nossa História</p>
            <h1 className="font-display text-white text-5xl md:text-7xl leading-tight max-w-3xl">
              {c.hero_title}
            </h1>
          </div>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-24 text-[#1A1A1A]">
        <p className="font-display text-2xl md:text-3xl leading-snug mb-8">{c.intro}</p>
        <p className="text-base text-[#6B6B6B] leading-relaxed mb-5">{c.paragraph_1}</p>
        <p className="text-base text-[#6B6B6B] leading-relaxed mb-5">{c.paragraph_2}</p>
        <p className="text-base text-[#6B6B6B] leading-relaxed mb-12">
          <span className="font-italic-display text-[#8C7B5E] text-xl">{c.paragraph_3}</span>
        </p>

        <div className="grid md:grid-cols-3 gap-10 mt-16 pt-12 border-t border-[#E8E4DF]">
          <div>
            <h3 className="font-display text-2xl mb-2">{c.value_1_title}</h3>
            <p className="text-sm text-[#6B6B6B]">{c.value_1_desc}</p>
          </div>
          <div>
            <h3 className="font-display text-2xl mb-2">{c.value_2_title}</h3>
            <p className="text-sm text-[#6B6B6B]">{c.value_2_desc}</p>
          </div>
          <div>
            <h3 className="font-display text-2xl mb-2">{c.value_3_title}</h3>
            <p className="text-sm text-[#6B6B6B]">{c.value_3_desc}</p>
          </div>
        </div>

        <div className="text-center mt-16">
          <Link to="/joias/todos" className="btn-primary">Conhecer a curadoria</Link>
        </div>
      </section>
    </div>
  );
}
